import { render, staticRenderFns } from "./EscuelasListado.vue?vue&type=template&id=6d24dbed&"
import script from "./EscuelasListado.vue?vue&type=script&lang=js&"
export * from "./EscuelasListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports